import axios from 'axios';
import { stringify } from 'qs';
import cookies from "@/services/cookies.service";
import store from "@/store";

class AuthService {
    async login(username: string, password: string) {
        const request = {
            grant_type: 'password',
            username,
            password,
            client_id: 'LactaFleet',
            client_secret: 'F55479D0-5AB4-419B-BFBE-FE1ED52B8C49'
        };

        const { data } = await axios.post('/connect/token', stringify(request));
        return data;
    }

    async tryLogin() {
        const refreshToken = cookies.get('refresh_token');
        if (refreshToken) {
            try {
                const accessToken = await store.dispatch('refreshToken', refreshToken);
                return accessToken;
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }

    async refreshToken(refreshToken: string) {
        const request = {
            grant_type: 'refresh_token',
            client_id: 'LactaFleet',
            client_secret: 'F55479D0-5AB4-419B-BFBE-FE1ED52B8C49',
            refresh_token: refreshToken
        };

        const { data } = await axios.post('/connect/token', stringify(request));
        return data;
    }

    logout() {
        cookies.remove('refresh_token');
        store.commit('setLoggedUser', '');
        axios.defaults.headers['Authentication'] = null;
    }
}

export default new AuthService();
